import Template from "../components/Template";
import { useActions } from "../redux/actions/UseActions";
import * as EventsActions from "../redux/actions/EventsActions";
import { useEffect, useState } from "react";
import { Grid, Icon, Label, Table } from "semantic-ui-react";
import { HelpMark } from "../components/help/HelpMark";
import { HELP_PAGE } from "../utils/HELP_PAGE";
import moment from "moment";

const Events = () => {
  const eventsAction = useActions(EventsActions);

  const [events, setEvents] = useState<any[]>();
  const [loading, setLoading] = useState<any>(false);

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    setLoading(true);
    const data = await eventsAction.getQueries({});
    setEvents(data);
    setLoading(false);
  };

  const getLogRow = (log: any) => {
    const isSuccess = log.status?.startsWith("Recall Created");
    const isFail = log.status?.startsWith("Recall Failed");

    return (
      <Table.Row key={log.id + "_log_row"}>
        <Table.Cell
          content={moment(log.createdAt).format("DD MMM yyyy @HH:mm")}
        />
        <Table.Cell>
          <Label content={log.watchTable} basic />
        </Table.Cell>
        <Table.Cell content={log.practiceId} />
        <Table.Cell content={log.entityId} />
        <Table.Cell content={log.payload} />
        <Table.Cell>
          <Icon
            name={
              isSuccess
                ? "check square outline"
                : isFail
                  ? "times rectangle"
                  : "dot circle"
            }
            color={isSuccess ? "green" : isFail ? "red" : "black"}
          />
          {log.status}
        </Table.Cell>
      </Table.Row>
    );
  };

  return (
    <Template activeLink="queries" loading={loading}>
      <br />
      <Grid>
        <Grid.Row>
          <Grid.Column width={10}>
            <h1>
              <span className="mr-2">Events</span>
              <HelpMark helpPage={HELP_PAGE.Queries} />
            </h1>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <br />

      <Table striped size="small" compact fixed>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={2} content="Date" />
            <Table.HeaderCell width={1} content="Watch Table" />
            <Table.HeaderCell width={1} content="Practice Id" />
            <Table.HeaderCell width={1} content="Table Id" />
            <Table.HeaderCell content="Data" />
            <Table.HeaderCell content="Status" />
          </Table.Row>
        </Table.Header>
        <Table.Body>{(events ?? []).map((log) => getLogRow(log))}</Table.Body>
      </Table>
    </Template>
  );
};

export default Events;
